import React from 'react';
import PropTypes from 'prop-types';
import {DropTarget} from 'react-dnd';
import * as DraggableItemType from 'common/components/dashboard/constants/draggable-item-type';
import {t} from 'common/utils/translation-util';
import './index.scss';

const addCardTarget = {
  canDrop() {
    return false;
  },

  hover(props, monitor) {
    const draggedId = monitor.getItem().id;
    const dragged = props.findCard(draggedId);

    if (
      dragged.colIndex !== props.colIndex ||
      dragged.index < props.reportsLength - 1
    ) {
      props.dropzone(null, props.reportsLength - 1);
    }
  },
};

const collectDrop = (connect) => ({
  connectDropTarget: connect.dropTarget(),
});

class DashboardAddCard extends React.Component {
  static propTypes = {
    colIndex: PropTypes.number.isRequired,
    connectDropTarget: PropTypes.func.isRequired,
    dropzone: PropTypes.func.isRequired,
    findCard: PropTypes.func.isRequired,
    reportsLength: PropTypes.number.isRequired,
  };

  render() {
    return this.props.connectDropTarget(
      <a
        className={'add-new-card createReport'}
        data-col={this.props.colIndex}
        href={'#'}>
        {t('+ Add a card')}
      </a>,
    );
  }
}

export default DropTarget(
  DraggableItemType.CARD,
  addCardTarget,
  collectDrop,
)(DashboardAddCard);
